import { render, staticRenderFns } from "./authenticationUser.vue?vue&type=template&id=72a3473e&scoped=true"
import script from "./authenticationUser.vue?vue&type=script&lang=js"
export * from "./authenticationUser.vue?vue&type=script&lang=js"
import style0 from "./authenticationUser.vue?vue&type=style&index=0&id=72a3473e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3473e",
  null
  
)

export default component.exports